export const base_url = "https://qtm.tubulu.in";

export const apiEndPoints = {
  supportForm: "/api/v1/supportForm",
};
